(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2731],{

/***/ 99783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-center/photo-gallery/[slug]",
      function () {
        return __webpack_require__(1373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23544);
/* harmony import */ var babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36492);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11232);
/* harmony import */ var utils_helperFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18991);
/* harmony import */ var services_photoGallery_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49881);









function PhotoGalleryDetails() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), locale = ref.locale, query = ref.query;
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)([
        "gallery-".concat(query.slug)
    ], function() {
        return (0,services_photoGallery_api__WEBPACK_IMPORTED_MODULE_4__/* .getGalleries */ .F)(locale, {
            filters: {
                slug: {
                    $eq: query.slug
                }
            }
        });
    }), images = ref1.data, isLoading = ref1.isLoading, isError = ref1.isError;
    if ((0,utils_helperFunction__WEBPACK_IMPORTED_MODULE_3__/* .isEmpty */ .xb)(images.data)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_2__/* .Redirect */ .l_, {});
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components__WEBPACK_IMPORTED_MODULE_2__/* .PhotoGallery */ .BQ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, images.data[0].attributes), {
        isLoading: isLoading,
        isError: isError
    }));
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,babel_plugin_superjson_next_tools__WEBPACK_IMPORTED_MODULE_0__.withSuperJSONPage)(PhotoGalleryDetails));


/***/ }),

/***/ 49881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getGalleries; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _qsStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55063);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35559);



var getGalleries = function(locale, queries) {
    var query = (0,_qsStringify__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        locale: locale,
        populate: [
            "images",
            "page_info.seo_info",
            "page_info.seo_info.image",
            "page_info.banner", 
        ],
        sort: [
            "createdAt:asc"
        ]
    }, queries));
    return _api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("/galleries?".concat(query)).then(function(res) {
        return res.data;
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(99783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);